import * as getters from "./map.getters";
import * as actions from "./map.actions";
import * as mutations from "./map.mutations";

const state = {
    mapGlSupported: true,
    mapLoaded: false,
    userLocationLoaded: false,
    mapAccessToken: 'G2g6W6x8VxtmmAkywFPDLQKQ',
    mapApimKey: '75a59d26d9cb4364ba23f9970513ca21',
    mapboxJsAccessToken: 'pk.eyJ1Ijoib2VhbXRjZ2VvMSIsImEiOiJja3JjNTcycjExNHB4Mm9xdTVvNDdvd3F0In0.wCRWFP3vS47A9CupY2nR_Q',
    activeMapStyle: 'day',
    mapTraffic: false,
    mapTrafficFromUrl: false,
    mapBounds: false,
    mapMoved: false,
    mapZoom: false,
    pinDrop: {
        data: false,
        loading: false
    },
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}